window.accordionToggle = function(node) {
    let accordion = node.closest('.js-accordion');
    let secondaryButton = accordion.querySelector('.accordion__button button > span');
    
    if(accordion.classList.contains('accordion--closed')) {
        accordion.classList.remove('accordion--closed');
        accordion.classList.add('accordion--opened');
        secondaryButton.innerHTML = secondaryButton.dataset.contentClose;
    }
    else {
        accordion.classList.add('accordion--closed');
        accordion.classList.remove('accordion--opened');
        secondaryButton.innerHTML = secondaryButton.dataset.contentOpen;
    }
}